export enum PillOptions {
  ALERT = 'alert',
  RISK = 'risk',
  TAG = 'tag',
}
